import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'platform',
            component: () => import(/* webpackChunkName: "platform" */ './views/platform.vue')
        },
        {
            path: '/login',
            name: 'home',
            component: Home
        },
        {
            path: '/platform',
            name: 'platform',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "platform" */ './views/platform.vue')
        },
        {
            path: '/register',
            name: 'register',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "regisiter" */ './views/register.vue')
        },
        {
            path: '/logout',
            name: 'logout',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "logout" */ './views/logout.vue')
        },
        {
            path: '/fromlogout',
            name: 'fromlogout',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "fromlogout" */ './views/fromlogout.vue')
        },
        {
            path: '/download',
            name: 'download',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "fromlogout" */ './views/download.vue')
        },
        {
            path: '/notauth',
            name: 'notauth',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "fromlogout" */ './views/notAuth.vue')
        }
    ]
})
